import { useContext, useEffect, useReducer, useRef, useState } from "react";
import { Context } from "../../context/Context";
import Notifications from "../../constants/Notifications";
import { GetDeviceNotifStatus, UpdateDeviceNotifyStatus } from "../../api/api";
import SuccessToast from "../toasts/SuccessToast";

const NotificationSettingsModal = ({
  setNotificationSettingsModal,
  device,
  update,
}) => {
  const { setIsLoading } = useContext(Context);

  const [title, setTitle] = useState(null);
  const [notifications, setNotifications] = useState([]);
  const [notifStatus, setNotifStatus] = useState([
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  ]);
  const [notifName, setNotifName] = useState([]);
  const [smsNotif, setSmsNotif] = useState(false);
  const [internetNotif, setInternetNotif] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const modalName = useRef(null);
  const closeButton = useRef(null);

  useEffect(() => {
    setNotificationSettingsModal(modalName);

    if (modalName.current) {
      const $modal = window.$(modalName.current);

      const handleShown = () => setIsModalOpen(true);
      const handleHidden = () => setIsModalOpen(false);

      $modal.on("shown.bs.modal", handleShown);
      $modal.on("hidden.bs.modal", handleHidden);

      return () => {
        $modal.off("shown.bs.modal");
        $modal.off("hidden.bs.modal");
      };
    }
  }, [setNotificationSettingsModal]);

  useEffect(() => {
    setNotifications([]);
    if (!isModalOpen) return;
    if (device) {
      const notifs = Notifications.find((n) => n.type == device.type);
      setNotifName(["RESERVED"]);
      setNotifStatus([
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ]);

      if (notifs) {
        setTitle(notifs.title);
      }

      setIsLoading(true);
      GetDeviceNotifStatus({
        device_serial: device.serial,
      }).then(({ data }) => {
        const newNotifNames = notifs?.data?.map((notif) => notif.name) || [];
        setNotifications(notifs?.data || []);
        if (data.status == 404) {
          setNotifName(["RESERVED", ...newNotifNames]);
        } else if (data.status == 200) {
          setNotifStatus(
            data.content.selected_inputs
              .toString(2)
              .padStart(21, "0")
              .split(""),
          );
          try {
            const parsedNames = JSON.parse(data.content.input_names);
            setNotifName(parsedNames);
          } catch (error) {
            console.error("Invalid JSON in input_names:", error);
            setNotifName([]);
          }
          setSmsNotif(data.content.enable_sms);
          setInternetNotif(data.content.enable_push);
        }
        setIsLoading(false);
      });
    }
  }, [device, update, isModalOpen]);

  const handleChangeNotifications = (index) => {
    const updatedStatus = [...notifStatus];
    const targetIndex = notifStatus.length - (index + 2);
    updatedStatus[targetIndex] = updatedStatus[targetIndex] == 1 ? 0 : 1;
    console.log('notifStatus is ', notifStatus);
    console.log('index is', index);
    console.log('targetIndex is ', targetIndex);
    console.log('updatedStatus is', updatedStatus);
    setNotifStatus(updatedStatus);
  };

  const handleChangeNotifName = (text, index) => {
    if (text.length > 20) return; // Exit if text is more than 20 characters
    const updatedName = [...notifName];
    const targetIndex = index + 1;
    updatedName[targetIndex] = text;

    setNotifName(updatedName); // Update state with modified array
  };

  const handleSubmit = () => {
    setIsLoading(true);
    UpdateDeviceNotifyStatus({
      device_serial: `${device.serial}`,
      notification_status: parseInt(notifStatus.join(""), 2),
      internet_token: device.internet_token,
      notification_names: JSON.stringify(notifName),
      internet_notify_status: internetNotif,
      sms_notify_status: smsNotif,
    }).then(({ data }) => {
      SuccessToast("با موفقیت ثبت شد");
      closeButton.current.click();
    }).finally(() => setIsLoading(false));
  };

  return (
    <div
      className="modal fade"
      id="scenarioTimerModal"
      tabIndex="-1"
      aria-labelledby="scenarioTimerModalLabel"
      aria-hidden="true"
      ref={modalName}
    >
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="equipmentsNameLabel">
              {title}
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              ref={closeButton}
            ></button>
          </div>
          <div className="modal-body">
            <div className="my-4">
              <div className="row">
                <div className="col col-sm-4"></div>
                <div className="col col-sm-4"></div>
                <div className="col col-sm-4">
                  <span className="text-muted">نام نمایشی</span>
                </div>
              </div>
              {notifications.map((notif, index) => (
                <div className="row my-2" key={index}>
                  <div className="col col-sm-4">
                    <span>{notif.name}</span>
                  </div>
                  <div className="col col-sm-4 mx-auto">
                    <label
                      className="switch switch-success-app w-auto"
                      style={{ marginLeft: "2.8rem" }}
                    >
                      <input
                        type="checkbox"
                        className="switch-input"
                        onChange={() => handleChangeNotifications(index)}
                        checked={
                          notifStatus[notifStatus.length - (index + 2)] == 1
                        }
                      />
                      <span className="switch-toggle-slider">
                        <span className="switch-on"></span>
                        <span className="switch-off"></span>
                      </span>
                    </label>
                  </div>
                  <div className="col col-sm-4">
                    <input
                      id="smallInput"
                      className="form-control form-control-sm"
                      type="text"
                      onChange={(e) =>
                        handleChangeNotifName(e.target.value, index)
                      }
                      value={notifName[index + 1]}
                    />
                  </div>
                </div>
              ))}
              <hr />
              <div className="row">
                <div className="col-12 col-sm-4 mb-2">
                  <span>نوع اعلان:</span>
                </div>
                <div className="col-12 col-sm-4 mb-2">
                  <label
                    className="switch switch-success-app w-auto"
                    style={{ marginLeft: "2.8rem" }}
                  >
                    <span className="switch-label px-0 pe-3">اینترنتی</span>
                    <input
                      type="checkbox"
                      className="switch-input"
                      onChange={() => setInternetNotif((prev) => !prev)}
                      checked={!!internetNotif}
                    />
                    <span className="switch-toggle-slider">
                      <span className="switch-on"></span>
                      <span className="switch-off"></span>
                    </span>
                  </label>
                </div>
                <div className="col-12 col-sm-4 mb-2">
                  <label
                    className="switch switch-success-app w-auto"
                    style={{ marginLeft: "2.8rem" }}
                  >
                    <span className="switch-label px-0 pe-3">پیامکی</span>
                    <input
                      type="checkbox"
                      className="switch-input"
                      onChange={() => setSmsNotif((prev) => !prev)}
                      checked={!!smsNotif}
                    />
                    <span className="switch-toggle-slider">
                      <span className="switch-on"></span>
                      <span className="switch-off"></span>
                    </span>
                  </label>
                </div>
              </div>
              <hr />
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-success-app mb-2"
              onClick={handleSubmit}
            >
              ذخیره
            </button>
            {/* <button
              type="button"
              className="btn btn-label-secondary mb-2"
              data-bs-dismiss="modal"
            >
              بستن
            </button> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationSettingsModal;
